export default class WindowQuery {
  add = (name, value) => {
    if (window.location.search.includes(name)) {
      const queries = window.location.search.split('&');
      const ind = queries.findIndex(q => q.includes(name));
      queries[ind] = `${queries[ind].split('=')[0]}=${value}`;

      window.history.pushState(
        null,
        null,
        `${window.location.pathname}${queries.join('&')}`
      );
      return this;
    }

    if (!window.location.pathname.includes('for-sale/')) {
      window.history.pushState(
        null,
        null,
        `${window.location.pathname}${window.location.search}${
          window.location.search === '' ? '?' : '&'
        }${name}=${value}`
      );
    }
    return this;
  };

  remove = name => {
    if (window.location.search.includes(name)) {
      const queries = window.location.search.substr(1).split('&');
      const ind = queries.findIndex(q => q.includes(name));
      queries.splice(ind, 1);
      window.history.pushState(
        null,
        null,
        `${window.location.pathname}?${queries.join('&')}`
      );
    }
    return this;
  };

  push = (prevUrl, param) => {
    window.localStorage.setItem('prevUrl', prevUrl);
    window.history.pushState({}, null, param);
    return this;
  };
}
